import { UnifiedWithdrawFormTranslations } from "./unified-withdraw-form-pt-br";

export const UNIFIED_WITHDRAW_FORM_FR_FR: UnifiedWithdrawFormTranslations = {
	drawerTitle: "Retrait et Transfert",
	steps: {
		information: "Informations",
		review: "Revue",
	},
	totalBalance: "Solde Total",
	sendTo: "Envoyer à",
	sendToPlaceholder: "Tapez ou sélectionnez le compte",
	addNewAccount: "+ Ajouter un nouveau compte",
	addAccountDrawerTitle: "Nouveau compte",
	saveAccount: "Enregistrer le compte",
	cancelAddAccount: "Annuler",
	defaultAccountBadge: "Compte par défaut",
	liquidValue: "Valeur Nette",
	liquidValuePlaceholder: "0,00 €",
	reason: "Motif de la demande",
	reasonPlaceholder: "Saisissez le motif du retrait",
	goBack: "Retour",
	goForward: "Suivant",
	submit: "Demander le retrait",
	errorMessage: "Impossible de traiter votre demande. Veuillez réessayer.",
	successMessage: "Votre demande de retrait a été envoyée avec succès !",
	splitBar: {
		available: "Disponible",
		anticipation: "Anticipation",
	},
	totalChipGross: "Total avec frais",
	anticipationFee: "Frais d'anticipation",
	thirdPartyFee: "Frais pour compte tiers",
	valueAboveTotal: "Montant demandé supérieur au total avec frais ({{value}})",
	withdrawBlockedFeeAboveBalance:
		"Solde insuffisant. Les frais pour compte tiers sont de {{fee}} et vous disposez de {{available}}.",
	feeError: {
		message: "Impossible de consulter les frais d'anticipation. Veuillez réessayer.",
		retry: "Réessayer",
	},
	review: {
		valuesReview: "Révision des valeurs",
		typeLabel: "Type",
		typeWithdraw: "Retrait",
		typeWithdrawAndAnticipation: "Retrait + Anticipation",
		statusLabel: "Statut",
		statusPending: "En traitement",
		requestedValue: "Montant demandé",
		walletValue: "Solde du portefeuille",
		anticipatedValue: "Montant anticipé",
		thirdPartyFeeLabel: "Frais pour compte tiers",
		anticipationFeeLabel: "Frais d'anticipation",
		grossValue: "Valeur brute",
		netValueToAccount: "Valeur nette",
		amountToReceive: "Montant à recevoir",
		attentionBannerTitle: "Attention",
		attentionBannerMessage:
			"Les demandes effectuées les jours ouvrés jusqu'à 15h59 (heure de Brasília) seront payées le jour même. Passé cette heure, elles seront traitées le jour ouvré suivant.",
		bankDataTitle: "Coordonnées bancaires",
		holderLabel: "Titulaire du compte",
		accountTypeLabel: "Type de compte",
		agencyLabel: "Agence",
		accountNumberLabel: "Numéro de compte",
		pixKeyLabel: "Clé PIX",
	},
	completion: {
		title: "Tout est en ordre !",
		description: "Le montant demandé est en cours de traitement par l'équipe Financière.",
		statusLabel: "Statut",
		statusProcessing: "En cours de traitement",
		amountToReceiveLabel: "Montant net à recevoir",
	},
	partialFailure: {
		modalTitle: "Demande partiellement traitée",
		modalDescription:
			"Une partie de votre demande a été traitée, mais l'autre partie n'a pas pu être effectuée.",
		title: "Traitement incomplet",
		message:
			"Une partie de l'opération a été effectuée, mais l'autre partie a échoué. Vérifiez le relevé et réessayez ce qui manque.",
		notification:
			"Demande partiellement traitée — vérifiez le relevé et réessayez ce qui manque.",
	},
};
